<template>
  <div>团体赛成绩查询</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
